// modal botão comprar
setTimeout(function () {
  const getModal = () => {
    return jQuery(".modal-buy-button-bg.productShelf");
  };
  var html = jQuery(document.documentElement);

  const closeModal = () => {
    getModal().css("display", "none").remove();
    html.css("overflowY", "auto");
  };

  // Adicionar um evento de clique a cada botão
  jQuery(document).on("click", ".btn-to-buy", function () {
    let button = jQuery(this);
    jQuery(button)
      .siblings(".btn-to-buy-loading")
      .attr("style", "display: block");

    //console.log(jQuery(this).attr("data"));

    let urlApi = "/wp-json/wp/v2/products/";
    const productId = jQuery(this).attr("data");
    let apiUrl = urlApi + productId;

    // Fazendo a requisição
    jQuery.ajax({
      url: apiUrl,
      method: "GET",
      success: function (data) {
        //console.log("data", data)

        const imgProduct = data.images.packshot || '';
        const titleproduct = data.title.rendered || '';
        const linkVarejo1 = data.acf.link_varejo_1;
        const linkVarejo3 = data.acf.link_varejo_3;
        const linkVarejo4 = data.acf.link_varejo_4;
        const linkVarejo7 = data.acf.link_varejo_7;

        const productInfoHTML = `
          <div id="modal-buy-button-bg" data="${titleproduct}" class="modal-buy-button-bg productShelf" style="display:none">
            <div class="modal-buy-button-container productShelf">
              <div class="modal-buy-button-content">
                <span class="modal-buy-button-close productShelf">X</span>
                <div class="modal-buy-button-product">
                  <img class="modal-buy-button-product-img" src="${
                    typeof imgProduct === "string" ? imgProduct : imgProduct.url
                  }">
                  <p class="modal-buy-button-title">Onde Comprar</p>
                  <p class="modal-buy-button-sub-title">${titleproduct}</p>
                </div>

                <div class="modal-buy-button-varejos-container">
                  <div class="modal-buy-button-varejos">
                    <div class="modal-buy-button-varejos-logo">
                      <img src="/wp-content/themes/seara/library/images/logo-varejos/pao_de_acucar_logo.webp" alt="logo_varejo" title="Logo Pão de Açúcar">
                    </div>
                    <div class="modal-buy-button-varejos-nome">Pão de Açúcar</div>
                    <div class="modal-buy-button-varejos-button">
                      ${
                        !linkVarejo1
                          ? '<a href="https://www.paodeacucar.com/especial/searabbb1" target="_blank" class="modal-buy-button">Comprar</a>'
                          : `<a href="${linkVarejo1}" class="modal-buy-button">Comprar</a>`
                      }
                    </div>
                  </div>

                  <div class="modal-buy-button-varejos">
                    <div class="modal-buy-button-varejos-logo">
                      <img src="/wp-content/themes/seara/library/images/logo-varejos/savegnago_logo.png"  alt="logo_varejo" title="Logo Savegnago">
                    </div>
                    <div class="modal-buy-button-varejos-nome">Savegnago</div>
                    <div class="modal-buy-button-varejos-button">
                      ${
                        !linkVarejo3
                          ? '<a href="https://www.savegnago.com.br/seara" target="_blank" class="modal-buy-button">Comprar</a>'
                          : `<a href="${linkVarejo3}" class="modal-buy-button">Comprar</a>`
                      }
                    </div>
                  </div>

                  <div class="modal-buy-button-varejos">
                    <div class="modal-buy-button-varejos-logo">
                      <img src="/wp-content/themes/seara/library/images/logo-varejos/tenda_logo.png" alt="logo_varejo" title="Logo Tenda">
                    </div>
                    <div class="modal-buy-button-varejos-nome">Tenda</div>
                    <div class="modal-buy-button-varejos-button">
                      ${
                        !linkVarejo4
                          ? '<a href="https://www.tendaatacado.com.br/busca?q=seara" target="_blank" class="modal-buy-button">Comprar</a>'
                          : `<a href="${linkVarejo4}" class="modal-buy-button">Comprar</a>`
                      }
                    </div>
                  </div>

                  <div class="modal-buy-button-varejos">
                    <div class="modal-buy-button-varejos-logo">
                      <img src="/wp-content/themes/seara/library/images/logo-varejos/muffato_logo.png" alt="logo_varejo" title="Logo Muffato">
                    </div>
                    <div class="modal-buy-button-varejos-nome">Muffato</div>
                    <div class="modal-buy-button-varejos-button">
                      ${
                        !linkVarejo7
                          ? '<a href="https://www.supermuffato.com.br/hotsites/seara" target="_blank" class="modal-buy-button">Comprar</a>'
                          : `<a href="${linkVarejo7}" class="modal-buy-button">Comprar</a>`
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img class="modal-content" id="modal-content">
          </div>
        `;

        // Inserindo o HTML na página
        jQuery("body").append(productInfoHTML);

        var closeBuyModal = jQuery(".modal-buy-button-close.productShelf");

        getModal().css("display", "block");
        html.css("overflowY", "hidden");
        jQuery(button)
          .siblings(".btn-to-buy-loading")
          .attr("style", "display: none");

        closeBuyModal.on("click", closeModal);

        jQuery(".modal-buy-button-container")
          .not(".modal-buy-button-content")
          .on("click", function (event) {
            let container = jQuery(".modal-buy-button-container.productShelf");
            if (event.target === container[0]) {
              closeModal();
            }
          });
      },
      error: function (error) {
        console.error("Houve um erro:", error);
      },
    });
    
    
  });
  const mobileBreakpoint = 768;

  // Verifica se está na versão mobile
  if (window.innerWidth <= mobileBreakpoint) {
      // Seleciona o elemento a ser movido
      const $buttonArea = jQuery(".button-area.desktop");

      // Seleciona a div de destino
      const $productImageWrapper = jQuery(".product-image-wrapper");

      if ($buttonArea.length && $productImageWrapper.length) {
          // Troca a classe de desktop para mobile
          $buttonArea.removeClass("desktop").addClass("mobile");

          // Move o botão para a div como o segundo elemento
          $buttonArea.insertAfter($productImageWrapper.children().first());

          // console.log("Elemento movido e classe alterada para mobile.");
      }
  }
}, 2000);